import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    z-index: 3;
  `,
  modal: css`
    align-items: flex-start;
    display: flex;
    padding: 0;
    flex-direction: column;
    height: 95vh;
    width: 95vw;
    max-width: 1366px;
    overflow: hidden;
  `,
  title: ({ theme }) => css`
    display: flex;
    width: 100%;
    height: 61px;
    text-align: left;
    align-items: center;
    padding: 12px 24px;
    flex-direction: row;
    border-bottom: solid 1px ${theme.colors.neutral.variant[20]};
  `,
  titleActions: css`
    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-left: auto;
  `,
  content: css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;

    max-height: calc(100% - 61px);
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
